import { ko } from 'date-fns/locale/ko';
import { decodeHTML } from 'entities';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useSearchParams } from 'react-router-dom';
import { getMAGAA000, postMAGAE010, putMAGAA000 } from '../../../services/Api';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MENUS } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas } from '../../../utils';
registerLocale('ko', ko);

const MAGAC010 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const [data, setData] = useState([]);
    const [display, setDisplay] = useState('N');
    const [searchCondition, setSearchCondition] = useState('Title');
    const [keyword, setKeyword] = useState('');
    const [dateRate, setDateRate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const freshDisplay = () => {
        getMAGAA000('pagac010')
            .then(({ data }) => {
                setDisplay(data.display);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        freshDisplay();
    }, []);

    const handleChangeDisplay = async (e) => {
        // const newDisplay = display === 'Y' ? 'N' : 'Y';
        try {
            await putMAGAA000('pagac010');
            freshDisplay();
        } catch (error) {
            console.log(error);
        }
    };

    const getSearchCondition = (e) => {
        setSearchCondition(e.target.value);
    };

    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        setDateRate('');
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const getGubun = (gubun) => {
        switch (gubun) {
            case 'QNA':
                return 'Q&A';
            case 'INTERVIEW':
                return '탐방';
            case 'COLUMN':
                return '덴탈칼럼';
            default:
                return '';
        }
    };

    const getListData = (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postMAGAE010({
            page: currentPage,
            searchCondition,
            keyword: keyword?.trim(),
            startDate: startDateFormated,
            endDate: endDateFormated,
        })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            clickSearch();
        }
    };
    const clickReset = () => {
        setSearchParams('');
        setStartDate('');
        setEndDate('');
        setDateRate('');
        setKeyword('');
        setSearchCondition('Title');
    };
    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    return (
        <div className="list-of-dental-journals container">
            <div className="wrap">
                <SideMenu menu={MENU_MENUS} />
                <div className="list-of-dental-journals-content content-right">
                    <h1 className="title">덴탈매거진</h1>
                    <div id="search-box">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>교육명</th>
                                    <td>
                                        <div className="select-box">
                                            <select onChange={getSearchCondition} value={searchCondition}>
                                                <option value="Title">제목</option>
                                                <option value="FTS_Contents">장소/연자</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="검색어 입력"
                                                value={keyword}
                                                onChange={inputChange}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>등록일</th>
                                    <td colSpan={3}>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                            <ul className="select-value">
                                                <li
                                                    value-date-range="today"
                                                    className={dateRate === 'today' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    오늘
                                                </li>
                                                <li
                                                    value-date-range="1week"
                                                    className={dateRate === '1week' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    일주일
                                                </li>
                                                <li
                                                    value-date-range="15days"
                                                    className={dateRate === '15days' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    15일
                                                </li>
                                                <li
                                                    value-date-range="1month"
                                                    className={dateRate === '1month' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    1개월
                                                </li>
                                                <li
                                                    value-date-range="3months"
                                                    className={dateRate === '3months' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    3개월
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>메뉴 표시</th>
                                    <td>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={handleChangeDisplay}
                                                checked={display === 'Y'}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="group-button center">
                            <button className="btn btn-gray-bold" onClick={clickSearch}>
                                검색
                            </button>
                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                초기화
                            </button>
                        </div>
                    </div>

                    <div className="button-item">
                        <Link to={'/magae020'}>덴탈매거진 등록</Link>
                    </div>

                    <div className="results">
                        <div className="count-item">
                            총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                        </div>
                        <table className="table-gray">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th>교육</th>
                                    <th>장소/연자</th>
                                    <th>공개여부</th>
                                    <th>조회수</th>
                                    <th>등록일</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{item.seq}</td>
                                                <td>
                                                    <span
                                                        className={`status ${item?.gubun === 'QNA'
                                                            ? 'purple'
                                                            : item?.gubun === 'INTERVIEW'
                                                                ? 'bg-success'
                                                                : 'bg-warning'
                                                            }`}
                                                    >
                                                        {getGubun(item?.gubun)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <Link to={`/magae030-${item.seq}`}>{decodeHTML(item.title)}</Link>
                                                </td>
                                                <td>
                                                    {item?.bizCompany} <br />
                                                    {item?.columnist}</td>
                                                <td>
                                                    {item?.dspYN === 'Y'
                                                        ? '공개'
                                                        : item?.dspYN === 'N'
                                                            ? '비공개'
                                                            : ''}
                                                </td>

                                                <td>{formatNumberWithCommas(item?.visitedCnt)}</td>
                                                <td>{formatDate(item?.addDate)}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={6}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div >
    );
};

export default MAGAC010;
